import React from "react";
import {useMediaQuery} from "react-responsive";
import PropTypes from "prop-types";
import classNames from "classnames";
import Sticky from "react-sticky-box";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import Links from "./Links";
import Contents from "./Contents";
import MobileContents from "./MobileContents";
import SocialLinks from "../SocialLinks";
import Clipboard from "../Clipboard";
import Clones from "../Clones";
import descriptions from "../../../mocks/product-descriptions";
import withErrorBoundary from "../../../decorators/withErrorBoundary";

import styles from "./description.module.scss";

function Description(props) {
  const isMobile = useMediaQuery({query: `(max-width: 940px)`});
  const {
    url,
    product: {
      singular: productName,
      name,
      title: itemTitle,
      description: itemDescription,
      views
    },
    seo,
    locationData,
    reviews,
    permalink,
    clones,
    priceList
  } = props;
  const isProductsApp = !url;
  const description =
    descriptions[productName] &&
    descriptions[productName]
      .filter(({id}) =>
        (id === `reviews` && !reviews.content.length) ||
        (!priceList && id === `price`)
          ? false
          : true
      )
      .filter((params) => !(params.hideOnMobile && !isMobile));
  return (
    description && (
      <div
        className={classNames(
          styles.root,
          isProductsApp ? styles.rootProducts : ``
        )}
      >
        <Grid container className={styles.desktopRoot}>
          <Grid
            item
            md={isProductsApp ? 9 : 7}
            xs={12}
            className={styles.contents}
          >
            <Contents
              productName={productName}
              items={description}
              seo={seo}
              locationData={locationData}
              reviews={reviews}
              priceList={priceList}
            />
          </Grid>
          <Grid
            item
            md={isProductsApp ? 3 : 5}
            xs={12}
            className={styles.links}
          >
            <Sticky offsetTop={60} offsetBottom={60}>
              <Links
                items={description.map(({id, title}) => ({
                  id: `${productName}-${id}`,
                  title
                }))}
              />
              <div className={styles.socialLinks}>
                {url && (
                  <SocialLinks
                    url={url}
                    title={`${name} ${itemTitle}`}
                    description={itemDescription}
                    media={
                      views && views.large && views.large[0]
                        ? views.large[0]
                        : `/`
                    }
                  />
                )}
                {permalink && (
                  <Clipboard
                    className={styles.clipboard}
                    label="Скопировать ссылку"
                    text={permalink}
                  />
                )}
              </div>
              {clones && (
                <div className={styles.clones}>
                  <Clones clones={clones} />
                </div>
              )}
            </Sticky>
          </Grid>
        </Grid>
        <Grid container className={styles.mobileRoot}>
          <Hidden mdUp>
            <Grid item xs={12}>
              <MobileContents
                items={description}
                seo={seo}
                locationData={locationData}
                reviews={reviews}
                priceList={priceList}
              />
            </Grid>
          </Hidden>
        </Grid>
      </div>
    )
  );
}

Description.propTypes = {
  url: PropTypes.string,
  product: PropTypes.object,
  seo: PropTypes.object,
  locationData: PropTypes.object,
  reviews: PropTypes.object,
  permalink: PropTypes.string,
  priceList: PropTypes.string,
  clones: PropTypes.array
};

export default withErrorBoundary(Description);
